import React from 'react';
import { Typography } from '@mui/material';
import BoxInputMain from './BoxInputMain';
import SelectMainDefault from './SelectMainDefault';

const SelectMain = ({
  field: fieldProp,
  form,
  ...props
}) => {
  const {
    value: fieldValue = '',
    ...fields
  } = fieldProp || {};

  const value = fieldValue ?? '';
  const errors = form?.errors || {};

  const {
    children,
    className,
    erro = '',
    onChangeSelect,
    placeholder = '',
    boxMain = true,
    ...restProps
  } = props;

  const nomeInput = fields.name;
  let erroTexto = errors?.[nomeInput] ?? '';

  if (erro !== '') {
    erroTexto = erro;
  }

  const erroExiste = erroTexto !== '';

  const onChangeSelectField = event => {
    if (typeof fields.onChange === 'function') {
      fields.onChange(event);
    }

    if (typeof onChangeSelect === 'function') {
      onChangeSelect(event);
    }
  };

  const select = (
    <>
      <SelectMainDefault
        {...restProps}
        value={value}
        name={fields.name}
        onChange={onChangeSelectField}
        className={className || ''}
        error={erroExiste}
        displayEmpty
        renderValue={
          value !== ''
            ? undefined
            : () => (
                <span className="color-placeholder">
                  {placeholder}
                </span>
              )
        }
      >
        {children}
      </SelectMainDefault>

      {erroTexto && (
        <Typography className="texto-danger label-padding">
          {erroTexto}
        </Typography>
      )}
    </>
  );

  return boxMain ? (
    <BoxInputMain {...restProps}>
      {select}
    </BoxInputMain>
  ) : (
    select
  );
};

export default SelectMain;